"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var config_1 = require("../shared/config");
var form_1 = require("../shared/form");
var http_1 = require("../shared/http");
var messages_1 = require("../shared/messages");
var dom_1 = require("../shared/dom");
var cookies_1 = require("../shared/cookies");
(0, jquery_1.default)(function () {
    if ((0, dom_1.queryParameterSet)("password_is_set")) {
        (0, messages_1.showSuccessMessage)("Het wachtwoord is succesvol gewijzigd. U kunt nu inloggen met uw gebruikersnaam en uw nieuwe wachtwoord.");
    }
    (0, jquery_1.default)('#login-form').on('submit', function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var $form, themeConfig, request, url, response, json, userType, redirect;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $form = (0, jquery_1.default)(this);
                        themeConfig = (0, config_1.getHovoThemeConfig)();
                        event.preventDefault();
                        request = (0, form_1.convertFormToJSON)($form);
                        url = "".concat((0, config_1.getApiRootUrl)(), "api/users/login");
                        return [4 /*yield*/, (0, http_1.postJson)(url, request)];
                    case 1:
                        response = _a.sent();
                        if (!(response && response.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        userType = json.type;
                        (0, cookies_1.setCookie)("hovo-token", json.token);
                        (0, cookies_1.setCookie)("hovo-user-type", userType);
                        redirect = (0, cookies_1.getCookie)("hovo-redirect");
                        if (redirect) {
                            location.href = redirect;
                            (0, cookies_1.removeCookie)("hovo-redirect");
                        }
                        else if (userType === "teacher") {
                            location.href = themeConfig.afterLoginRedirectTeacherUrl || themeConfig.siteRootUrl;
                        }
                        else {
                            location.href = themeConfig.afterLoginRedirectUrl || themeConfig.siteRootUrl;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        (0, messages_1.showErrorMessage)("De door u ingegeven gebruikersnaam/wachtwoordcombinatie is onjuist.");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    });
});
